import React from 'react';

/**
 * BuybackModal — Old Mobile: customer se wapas kharidna.
 * Sabhi state Inventory.js mein hai; ye component sirf UI hai.
 *
 * Props:
 *   buybackModal        — { productName, imei1, imei2, customerName, customerPhone,
 *                           lastSalePrice, hasEmi } | null
 *   buybackPriceInput   — string
 *   buybackNotesInput   — string
 *   buybackSubmitting   — boolean
 *   onPriceChange(val)  — sets buybackPriceInput
 *   onNotesChange(val)  — sets buybackNotesInput
 *   onSubmit()          — submitOldMobileBuyback
 *   onClose()           — setBuybackModal(null)
 */
export default function BuybackModal({
  buybackModal,
  buybackPriceInput,
  buybackNotesInput,
  buybackSubmitting,
  onPriceChange,
  onNotesChange,
  onSubmit,
  onClose
}) {
  if (!buybackModal) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-success text-white">
            <h5 className="modal-title mb-0">Old Mobile — customer se buy back</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              disabled={buybackSubmitting}
              onClick={onClose}
              aria-label="Close"
            />
          </div>

          <div className="modal-body">
            <p className="small text-muted mb-2">
              <strong>{buybackModal.productName}</strong>
              <br />
              IMEI: <code>{buybackModal.imei1}</code>
              {buybackModal.imei2 ? (
                <> · <code>{buybackModal.imei2}</code></>
              ) : null}
            </p>

            <p className="mb-2 small">
              <strong>Ab jo wapas bech raha hai:</strong> {buybackModal.customerName || '—'}{' '}
              <span className="text-muted">{buybackModal.customerPhone || ''}</span>
            </p>

            {buybackModal.hasEmi ? (
              <div className="alert alert-warning py-2 small mb-2">
                Is sale par EMI link thi — zarurat ho to EMI dashboard se plan check / complete karein.
              </div>
            ) : null}

            <p className="small text-muted mb-3">
              Original <strong>unit seller</strong> (pehli intake) same rahega. Sirf unit dubara{' '}
              <strong>available</strong> ho jayega.
            </p>

            <div className="mb-3">
              <label className="form-label">Buyback amount (₹) *</label>
              <input
                type="number"
                className="form-control"
                min="1"
                step="1"
                value={buybackPriceInput}
                onChange={(e) => onPriceChange(e.target.value)}
                placeholder={
                  buybackModal.lastSalePrice != null
                    ? `Last sale ₹${buybackModal.lastSalePrice.toLocaleString('en-IN')}`
                    : 'Jo amount customer ko de rahe ho'
                }
              />
            </div>

            <div className="mb-0">
              <label className="form-label">Notes (optional)</label>
              <textarea
                className="form-control form-control-sm"
                rows={2}
                value={buybackNotesInput}
                onChange={(e) => onNotesChange(e.target.value)}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              disabled={buybackSubmitting}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success"
              disabled={buybackSubmitting}
              onClick={onSubmit}
            >
              {buybackSubmitting ? 'Saving…' : 'Confirm buyback'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
